import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import api from '../../lib/api';
import { Button } from '../../components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';

export function VergunningDialog({ vehicle, onClose, onSaved }) {
  const [codes, setCodes] = useState([]);
  const [selected, setSelected] = useState(vehicle.vergunning_codes || []);
  const [types, setTypes] = useState(vehicle.vergunning_types || {});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/vergunning-codes', { params: vehicle.firm_id ? { firm_id: vehicle.firm_id } : {} })
      .then((r) => setCodes(r.data?.data || [])).catch(() => toast.error('Kodlar yüklenemedi'));
  }, [vehicle.firm_id]);

  const toggle = (code) => setSelected((s) => (s.includes(code) ? s.filter((c) => c !== code) : [...s, code]));
  const save = async () => {
    setSaving(true);
    try {
      const t = Object.fromEntries(selected.map((c) => [c, types[c] || 'ORIGINAL']));
      await api.put(`/vehicles/${vehicle.id}/vergunning-codes`, { codes: selected, types: t });
      toast.success('Vergunning güncellendi');
      onSaved();
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || 'Kaydedilemedi'); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="vergunning-quick-dialog">
        <DialogHeader><DialogTitle>Vergunning — {vehicle.license_plate}</DialogTitle></DialogHeader>
        {codes.length === 0 ? <p className="text-sm text-slate-500 py-4">Bu firmaya tanımlı vergunning kodu yok.</p> : (
          <div className="space-y-1.5 max-h-80 overflow-y-auto">
            {codes.map((c) => {
              const on = selected.includes(c.code);
              return (
                <div key={c.id} className={`flex items-center justify-between rounded-lg border px-3 py-2 ${on ? 'border-sky-400 bg-sky-50 dark:bg-sky-950/30' : 'border-slate-200 dark:border-slate-700'}`}>
                  <label className="flex items-center gap-2 text-sm cursor-pointer">
                    <input type="checkbox" checked={on} onChange={() => toggle(c.code)} data-testid={`vergunning-code-${c.code}`} />
                    <span className="font-semibold">{c.code}</span>
                    <span className="text-xs text-slate-500">{c.vehicle_count ? `${c.vehicle_count} araçta` : ''}</span>
                  </label>
                  {on && (
                    <select value={types[c.code] || 'ORIGINAL'} onChange={(e) => setTypes((t) => ({ ...t, [c.code]: e.target.value }))}
                      className="text-xs border rounded px-1.5 py-0.5 dark:bg-slate-800 dark:border-slate-600" data-testid={`vergunning-type-${c.code}`}>
                      <option value="ORIGINAL">Orijinal</option>
                      <option value="COPY">Kopya</option>
                    </select>
                  )}
                </div>
              );
            })}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>İptal</Button>
          <Button onClick={save} disabled={saving} data-testid="vergunning-quick-save">{saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Kaydet</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
